import './styles.scss';

import React, { useCallback } from 'react';

import { marked } from 'marked';
import LazyLoad from 'react-lazyload';

import { BubbleSVG } from '../../components/BubbleSVG';
import { Button } from '../../components/Button';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { VisibleOn } from '../../components/VisibleOn';
import { useRouter } from '../../hooks';
import { classNames } from '../../services/classNames';
import { Storyblok, StoryblokSection } from '../../storyblok';

export const BubbleSection = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.BubbleSection>) => {
    const {
        component,
        background_image,
        background_image_mobile,
        button_url,
        button_title,
        description,
        section_style,
        title,
        tracking_event_action_name,
    } = sectionData;
    const { navigate } = useRouter();

    const buttonUrl = button_url.cached_url;
    const buttonTitle = button_title;

    const changeSceneHandler = useCallback(() => {
        window.scrollTo(0, 0);
        navigate(buttonUrl);
    }, [navigate]);

    return (
        <section
            className={classNames(
                'ContentWithBubble',
                section_style &&
                    `ContentWithBubble--bubbleHomepage${section_style}`,
            )}
            data-block={component}
        >
            <LazyLoad offset={200}>
                {background_image && (
                    <VisibleOn tablet desktop>
                        <ResponsiveImage
                            image={background_image}
                            className="ContentWithBubble__Background"
                            objectFit
                        />
                    </VisibleOn>
                )}
                {background_image_mobile && (
                    <VisibleOn mobile>
                        <ResponsiveImage
                            image={background_image_mobile}
                            className="ContentWithBubble__Background"
                            objectFit
                        />
                    </VisibleOn>
                )}
            </LazyLoad>

            <div className="ContentWithBubble__Bubble">
                {button_title && (
                    <button
                        type="button"
                        onClick={changeSceneHandler}
                        className="ContentWithBubble__Bubble-link"
                    >
                        <BubbleSVG
                            backgroundSvgName={`bubbleHomepage${section_style}`}
                        >
                            {title && <h3>{title}</h3>}
                            <div
                                className="ContentWithBubble__Bubble-text"
                                dangerouslySetInnerHTML={{
                                    __html: marked(description),
                                }}
                            />
                            {buttonUrl && buttonTitle && (
                                <Button
                                    to={buttonUrl}
                                    variant="secondary"
                                    className="ContentWithBubble__Bubble-button"
                                >
                                    {buttonTitle}
                                </Button>
                            )}
                        </BubbleSVG>
                    </button>
                )}
            </div>
        </section>
    );
};
